"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RelayHooksType_1 = require("./RelayHooksType");

exports.convertDataFrom = function (dataFrom) {
  if (dataFrom === void 0) {
    dataFrom = RelayHooksType_1.STORE_OR_NETWORK;
  }

  switch (dataFrom) {
    case RelayHooksType_1.NETWORK_ONLY:
      return "network-only";

    case RelayHooksType_1.STORE_THEN_NETWORK:
      return "store-and-network";

    case RelayHooksType_1.STORE_ONLY:
      return "store-only";

    default:
      return "store-or-network";
  }
};

exports.isNetworkPolicy = function (policy, storeSnapshot) {
  return policy === "network-only" || policy === "store-and-network" || policy === "store-or-network" && !storeSnapshot;
};

exports.isStorePolicy = function (policy) {
  return policy !== "network-only";
};